'use client'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Link } from '@/i18n/navigation'

import { useWorkContext } from './work-context'

export const UserAvatar = () => {
  const { data } = useWorkContext()

  return (
    <Link
      className="pointer-events-auto relative size-9 rounded-full"
      href={`https://digen.ai/@${data?.nickName}`}
    >
      <Avatar className="size-full">
        <AvatarImage alt={data?.nickName} src={data?.faceURL} />
        <AvatarFallback>{data?.nickName?.charAt(0)?.toUpperCase()}</AvatarFallback>
      </Avatar>
      {/* <Button
        className="!absolute -right-0.5 -bottom-1 size-4 bg-white hover:bg-white"
        size="icon"
        variant="ghost"
      >
        <PlusIcon color="black" weight="bold" />
      </Button> */}
    </Link>
  )
}
